(() => {
  if (customElements.get('babauba-bonus-progress')) return;

  const sectionId = 'babauba-bonus-state';
  let latestState = null;
  let updateId = 0;
  let refreshController;

  function applyState(state) {
    const count = Number(state?.dataset.count);
    if (!Number.isInteger(count) || count < 0) return;
    latestState = state;
    document.querySelectorAll('babauba-bonus-progress').forEach((element) => element.update?.(state));
  }

  function parseState(html) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bonus-state]');
  }

  async function updateFromCart(payload) {
    if (!payload?.cart || payload.cart.errors || payload.cart.status) return;
    const requestId = ++updateId;
    refreshController?.abort();
    const html = payload.cart.sections?.[sectionId];
    if (html) {
      applyState(parseState(html));
      return;
    }

    // App-triggered updates can omit bundled sections. Refresh the same server state once.
    const controller = new AbortController();
    refreshController = controller;
    try {
      const url = new URL(FoxTheme.routes.root_url, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error(`Bonus state request failed (${response.status})`);
      const responseText = await response.text();
      if (requestId === updateId && !controller.signal.aborted) applyState(parseState(responseText));
    } catch (error) {
      if (error.name !== 'AbortError') console.error(error);
    }
  }

  class BabaubaBonusProgress extends HTMLElement {
    connectedCallback() {
      if (latestState) this.update(latestState);
      else applyState(this.querySelector('[data-bonus-state]'));
    }

    update(state) {
      const target = this.querySelector('[data-bonus-status]');
      if (!target) return;
      target.innerHTML = state.outerHTML;
    }
  }

  customElements.define('babauba-bonus-progress', BabaubaBonusProgress);
  document.addEventListener('cart:grouped-sections', (event) => {
    const sections = event.detail.sections;
    if (!sections.includes(sectionId) && sections.length < 5) sections.push(sectionId);
  });
  // CartDrawer refresh replaces its header from a fresh server response.
  document.addEventListener('cart:refresh', () => {
    ++updateId;
    refreshController?.abort();
    latestState = null;
  });
  FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, updateFromCart);
})();
